var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cad_dwg_preview"},[_c('div',{ref:"cadHost",staticClass:"cad_canvas"}),(_vm.loading)?_c('div',{staticClass:"cad_state"},[_vm._v("DWG 加载中...")]):_vm._e(),(_vm.errorMessage)?_c('div',{staticClass:"cad_state cad_error"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }